/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';
import { createAction } from 'redux-actions';

import { LIST_GROUPS, SET_GROUP, SET_GROUP_DROPDOWN } from './types';

export const listGroups = createRoutine(LIST_GROUPS);
export const setGroup = createAction(SET_GROUP);
export const setGroupDropdown = createAction(SET_GROUP_DROPDOWN);
